export function colors() {
  return [
    '#FFB400', // gold
    '#03A3E4', // blue
    '#7FB800', // green
    '#0D2C54', // violet
    '#F6511D', // orange
  ]
}
